<template>
  <div class="NCTUDDB-login">

    <a-button size="small" icon="el-icon-chat-round" @click="showDrawer" shape="round">
      <span class="hidden-sm-and-down">{{userName}}</span>
      <a-icon type="user"/>
    </a-button>
    <el-drawer
        size="70%"
        :visible.sync="isDrawerShow"
        direction="rtl">
      <el-card style="border-radius: 30px">
        <span>
              <el-avatar icon="el-icon-user-solid"></el-avatar>
          <div>
            <a>{{ userName }}</a>
            <el-input v-model="user.displayName" placeholder="輸入給別人看的暱稱">{{ userName }}</el-input>
          </div>
      </span>
      </el-card>
      <el-dropdown>
        <el-button type="primary">
          {{ user.dep }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="dep of depOptions" :key="dep.cname" @click.native="user.dep = dep.cname">
            {{ dep.cname }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <el-button type="primary">
          {{ user.grade }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="user.grade = '大一'">大一</el-dropdown-item>
          <el-dropdown-item @click.native="user.grade = '大二'">大二</el-dropdown-item>
          <el-dropdown-item @click.native="user.grade = '大三'">大三</el-dropdown-item>
          <el-dropdown-item @click.native="user.grade = '大四'">大四</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-button v-if="!isLogin" style="width: 100%">
        <el-link
            href="https://id.nctu.edu.tw/o/authorize/?client_id=4JrFF39B22st9E8U6ZnFjbUEMDNO1MfnTs005FOH&response_type=code&scope=profile%20name%20status">
          <h1>以 NCTU OAuth 登入</h1></el-link>
      </el-button>
      <el-button v-else @click="signOutUser">
        <h1>登出</h1>
      </el-button>
    </el-drawer>
  </div>
</template>
<script>

// const NodeRSA = require('node-rsa')

import {findDepEnum, findDepGroup} from "@/courseProcessor";

export default {
  name: 'UserLoginDrawer',
  data() {
    return {
      isDrawerShow: false,
      account: '',
      password: '',
      depOptions: []
    }
  },
  methods: {
    showDrawer() {
      this.isDrawerShow = true
      this.depOptions = findDepGroup(Object.values(findDepEnum(this.allCoursesList)))['大學部'].child
    },
    signOutUser() {
      this.user.loginInfo = {name: 'anonymous', login: false, code: null, expire: null}
    }
  },
  computed: {
    isLogin() {
      return this.user.loginInfo.login;
    },
    userName() {
      return this.isLogin ? this.user.loginInfo.name : "未登入"
    }
  }
}
</script>
<style>
</style>
